export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6583.51336fc4.jpg";